/**
 * Bundle versions written by the local device-run scripts
 * (`scripts/cap-run-stg.ts`) start with this prefix. Such a build runs the
 * developer's checkout and must not be replaced by the env's deployed bundle.
 */
export const DEV_BUILD_VERSION_PREFIX = "dev-";

export interface UpdateDecisionInput {
  /** Latest store build number from Firebase Remote Config. */
  latestBuildNumber: number | undefined;
  /** The installed native build number. */
  currentBuildNumber: number;
  /** `version` of the `/config.json` at `capacitorAppUrl`. */
  latestVersion: string | undefined;
  /** `version` of the running bundle's `/config.json`. */
  currentVersion: string | undefined;
}

export interface UpdateDecision {
  needStoreUpdate: boolean;
  needOTAUpdate: boolean;
  needOTAClean: boolean;
}

export function decideUpdate({
  latestBuildNumber,
  currentBuildNumber,
  latestVersion,
  currentVersion,
}: UpdateDecisionInput): UpdateDecision {
  const decision: UpdateDecision = {
    needStoreUpdate: false,
    needOTAUpdate: false,
    needOTAClean: false,
  };
  if (!latestBuildNumber) return decision;
  // we received build number from firebase, checking if update from store is required
  if (currentBuildNumber < latestBuildNumber) {
    decision.needStoreUpdate = true;
    return decision;
  }
  // Skip the OTA-update path when either side is missing version —
  // happens during the Phase-8 rollout window. Treat as "in-sync"
  // rather than triggering false positives. A dev build keeps its own
  // bundle as well.
  if (
    latestVersion &&
    currentVersion &&
    latestVersion !== currentVersion &&
    !currentVersion.startsWith(DEV_BUILD_VERSION_PREFIX)
  ) {
    decision.needOTAUpdate = true;
  } else {
    decision.needOTAClean = true;
  }
  return decision;
}
